module.exports = __webpack_public_path__ + "assets/90047c93c893133b5e79eae410238d2c.png";